// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file luwu/v1/term.proto (package luwu.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file luwu/v1/term.proto.
 */
export const file_luwu_v1_term: GenFile = /*@__PURE__*/
  fileDesc("ChJsdXd1L3YxL3Rlcm0ucHJvdG8SB2x1d3UudjEiYAoIVGVybU9wZW4SEgoKc2Vzc2lvbl9pZBgBIAEoCRIRCgl3aW5kb3dfaWQYAiABKAkSDAoEY29scxgDIAEoDRIMCgRyb3dzGAQgASgNEhEKCXJlYWRfb25seRgFIAEoCCIZCglUZXJtSW5wdXQSDAoEZGF0YRgBIAEoDCIoCgpUZXJtUmVzaXplEgwKBGNvbHMYASABKA0SDAoEcm93cxgCIAEoDSIoCglUZXJtUGFzdGUSDAoEdGV4dBgBIAEoCRINCgVlbnRlchgCIAEoCCIfCg5UZXJtSGlzdG9yeVJlcRINCgVsaW5lcxgBIAEoDSIlChBUZXJtU2VsZWN0V2luZG93EhEKCXdpbmRvd19pZBgBIAEoCSILCglUZXJtQ2xvc2UiFQoHVGVybUZpdBIKCgJvbhgBIAEoCCLEAgoKVGVybUNsaWVudBIhCgRvcGVuGAEgASgLMhEubHV3dS52MS5UZXJtT3BlbkgAEiMKBWlucHV0GAIgASgLMhIubHV3dS52MS5UZXJtSW5wdXRIABIlCgZyZXNpemUYAyABKAsyEy5sdXd1LnYxLlRlcm1SZXNpemVIABIjCgVwYXN0ZRgEIAEoCzISLmx1d3UudjEuVGVybVBhc3RlSAASKgoHaGlzdG9yeRgFIAEoCzIXLmx1d3UudjEuVGVybUhpc3RvcnlSZXFIABIrCgZzZWxlY3QYBiABKAsyGS5sdXd1LnYxLlRlcm1TZWxlY3RXaW5kb3dIABIjCgVjbG9zZRgHIAEoCzISLmx1d3UudjEuVGVybUNsb3NlSAASHwoDZml0GAggASgLMhAubHV3dS52MS5UZXJtRml0SABCAwoBbSJICgpUZXJtT3BlbmVkEhEKCXZpZXdlcl9pZBgBIAEoCRIRCgl3aW5kb3dfaWQYAiABKAkSFAoMaWdub3Jlc19zaXplGAMgASgIIhgKCFRlcm1EYXRhEgwKBGRhdGEYASABKAwiGwoLVGVybUhpc3RvcnkSDAoEZGF0YRgBIAEoDCIaCghUZXJtRXhpdBIOCgZyZWFzb24YASABKAkiLAoOVGVybVdpbmRvd1NpemUSDAoEY29scxgBIAEoDRIMCgRyb3dzGAIgASgNItUBCghUZXJtSG9zdBIlCgZvcGVuZWQYASABKAsyEy5sdXd1LnYxLlRlcm1PcGVuZWRIABIhCgRkYXRhGAIgASgLMhEubHV3dS52MS5UZXJtRGF0YUgAEicKB2hpc3RvcnkYAyABKAsyFC5sdXd1LnYxLlRlcm1IaXN0b3J5SAASIQoEZXhpdBgEIAEoCzIRLmx1d3UudjEuVGVybUV4aXRIABIuCgt3aW5kb3dfc2l6ZRgFIAEoCzIXLmx1d3UudjEuVGVybVdpbmRvd1NpemVIAEIDCgFtQihaJmx1d3UuZGV2L2dvL2ludGVybmFsL3BiL2x1d3UvdjE7bHV3dXYxYgZwcm90bzM");

/**
 * /luwu/term/1.0.0 — one stream per viewer.
 *
 * @generated from message luwu.v1.TermOpen
 */
export type TermOpen = Message<"luwu.v1.TermOpen"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string window_id = 2;
   */
  windowId: string;

  /**
   * @generated from field: uint32 cols = 3;
   */
  cols: number;

  /**
   * @generated from field: uint32 rows = 4;
   */
  rows: number;

  /**
   * @generated from field: bool read_only = 5;
   */
  readOnly: boolean;
};

/**
 * Describes the message luwu.v1.TermOpen.
 * Use `create(TermOpenSchema)` to create a new message.
 */
export const TermOpenSchema: GenMessage<TermOpen> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 0);

/**
 * @generated from message luwu.v1.TermInput
 */
export type TermInput = Message<"luwu.v1.TermInput"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message luwu.v1.TermInput.
 * Use `create(TermInputSchema)` to create a new message.
 */
export const TermInputSchema: GenMessage<TermInput> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 1);

/**
 * @generated from message luwu.v1.TermResize
 */
export type TermResize = Message<"luwu.v1.TermResize"> & {
  /**
   * @generated from field: uint32 cols = 1;
   */
  cols: number;

  /**
   * @generated from field: uint32 rows = 2;
   */
  rows: number;
};

/**
 * Describes the message luwu.v1.TermResize.
 * Use `create(TermResizeSchema)` to create a new message.
 */
export const TermResizeSchema: GenMessage<TermResize> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 2);

/**
 * @generated from message luwu.v1.TermPaste
 */
export type TermPaste = Message<"luwu.v1.TermPaste"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: bool enter = 2;
   */
  enter: boolean;
};

/**
 * Describes the message luwu.v1.TermPaste.
 * Use `create(TermPasteSchema)` to create a new message.
 */
export const TermPasteSchema: GenMessage<TermPaste> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 3);

/**
 * @generated from message luwu.v1.TermHistoryReq
 */
export type TermHistoryReq = Message<"luwu.v1.TermHistoryReq"> & {
  /**
   * @generated from field: uint32 lines = 1;
   */
  lines: number;
};

/**
 * Describes the message luwu.v1.TermHistoryReq.
 * Use `create(TermHistoryReqSchema)` to create a new message.
 */
export const TermHistoryReqSchema: GenMessage<TermHistoryReq> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 4);

/**
 * @generated from message luwu.v1.TermSelectWindow
 */
export type TermSelectWindow = Message<"luwu.v1.TermSelectWindow"> & {
  /**
   * @generated from field: string window_id = 1;
   */
  windowId: string;
};

/**
 * Describes the message luwu.v1.TermSelectWindow.
 * Use `create(TermSelectWindowSchema)` to create a new message.
 */
export const TermSelectWindowSchema: GenMessage<TermSelectWindow> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 5);

/**
 * @generated from message luwu.v1.TermClose
 */
export type TermClose = Message<"luwu.v1.TermClose"> & {
};

/**
 * Describes the message luwu.v1.TermClose.
 * Use `create(TermCloseSchema)` to create a new message.
 */
export const TermCloseSchema: GenMessage<TermClose> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 6);

/**
 * Fit asks to size the shared tmux window to this viewer (on) or to stop
 * affecting its size again (off). Viewers that join a session someone else
 * is using start without affecting its size.
 *
 * @generated from message luwu.v1.TermFit
 */
export type TermFit = Message<"luwu.v1.TermFit"> & {
  /**
   * @generated from field: bool on = 1;
   */
  on: boolean;
};

/**
 * Describes the message luwu.v1.TermFit.
 * Use `create(TermFitSchema)` to create a new message.
 */
export const TermFitSchema: GenMessage<TermFit> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 7);

/**
 * @generated from message luwu.v1.TermClient
 */
export type TermClient = Message<"luwu.v1.TermClient"> & {
  /**
   * @generated from oneof luwu.v1.TermClient.m
   */
  m: {
    /**
     * @generated from field: luwu.v1.TermOpen open = 1;
     */
    value: TermOpen;
    case: "open";
  } | {
    /**
     * @generated from field: luwu.v1.TermInput input = 2;
     */
    value: TermInput;
    case: "input";
  } | {
    /**
     * @generated from field: luwu.v1.TermResize resize = 3;
     */
    value: TermResize;
    case: "resize";
  } | {
    /**
     * @generated from field: luwu.v1.TermPaste paste = 4;
     */
    value: TermPaste;
    case: "paste";
  } | {
    /**
     * @generated from field: luwu.v1.TermHistoryReq history = 5;
     */
    value: TermHistoryReq;
    case: "history";
  } | {
    /**
     * @generated from field: luwu.v1.TermSelectWindow select = 6;
     */
    value: TermSelectWindow;
    case: "select";
  } | {
    /**
     * @generated from field: luwu.v1.TermClose close = 7;
     */
    value: TermClose;
    case: "close";
  } | {
    /**
     * @generated from field: luwu.v1.TermFit fit = 8;
     */
    value: TermFit;
    case: "fit";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message luwu.v1.TermClient.
 * Use `create(TermClientSchema)` to create a new message.
 */
export const TermClientSchema: GenMessage<TermClient> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 8);

/**
 * @generated from message luwu.v1.TermOpened
 */
export type TermOpened = Message<"luwu.v1.TermOpened"> & {
  /**
   * @generated from field: string viewer_id = 1;
   */
  viewerId: string;

  /**
   * @generated from field: string window_id = 2;
   */
  windowId: string;

  /**
   * True when the viewer doesn't affect the window size (another client
   * was attached); TermFit turns that off.
   *
   * @generated from field: bool ignores_size = 3;
   */
  ignoresSize: boolean;
};

/**
 * Describes the message luwu.v1.TermOpened.
 * Use `create(TermOpenedSchema)` to create a new message.
 */
export const TermOpenedSchema: GenMessage<TermOpened> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 9);

/**
 * @generated from message luwu.v1.TermData
 */
export type TermData = Message<"luwu.v1.TermData"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message luwu.v1.TermData.
 * Use `create(TermDataSchema)` to create a new message.
 */
export const TermDataSchema: GenMessage<TermData> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 10);

/**
 * @generated from message luwu.v1.TermHistory
 */
export type TermHistory = Message<"luwu.v1.TermHistory"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message luwu.v1.TermHistory.
 * Use `create(TermHistorySchema)` to create a new message.
 */
export const TermHistorySchema: GenMessage<TermHistory> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 11);

/**
 * @generated from message luwu.v1.TermExit
 */
export type TermExit = Message<"luwu.v1.TermExit"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message luwu.v1.TermExit.
 * Use `create(TermExitSchema)` to create a new message.
 */
export const TermExitSchema: GenMessage<TermExit> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 12);

/**
 * The tmux window's size. It differs from the viewer's own size when
 * another client (e.g. the computer's own terminal) owns the window size;
 * viewers can then zoom out to show the whole window.
 *
 * @generated from message luwu.v1.TermWindowSize
 */
export type TermWindowSize = Message<"luwu.v1.TermWindowSize"> & {
  /**
   * @generated from field: uint32 cols = 1;
   */
  cols: number;

  /**
   * @generated from field: uint32 rows = 2;
   */
  rows: number;
};

/**
 * Describes the message luwu.v1.TermWindowSize.
 * Use `create(TermWindowSizeSchema)` to create a new message.
 */
export const TermWindowSizeSchema: GenMessage<TermWindowSize> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 13);

/**
 * @generated from message luwu.v1.TermHost
 */
export type TermHost = Message<"luwu.v1.TermHost"> & {
  /**
   * @generated from oneof luwu.v1.TermHost.m
   */
  m: {
    /**
     * @generated from field: luwu.v1.TermOpened opened = 1;
     */
    value: TermOpened;
    case: "opened";
  } | {
    /**
     * @generated from field: luwu.v1.TermData data = 2;
     */
    value: TermData;
    case: "data";
  } | {
    /**
     * @generated from field: luwu.v1.TermHistory history = 3;
     */
    value: TermHistory;
    case: "history";
  } | {
    /**
     * @generated from field: luwu.v1.TermExit exit = 4;
     */
    value: TermExit;
    case: "exit";
  } | {
    /**
     * @generated from field: luwu.v1.TermWindowSize window_size = 5;
     */
    value: TermWindowSize;
    case: "windowSize";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message luwu.v1.TermHost.
 * Use `create(TermHostSchema)` to create a new message.
 */
export const TermHostSchema: GenMessage<TermHost> = /*@__PURE__*/
  messageDesc(file_luwu_v1_term, 14);

